import React, {Component} from 'react'
import {connect} from 'react-redux'
import {withRouter} from 'react-router-dom'
import {Table, Alert} from 'react-bootstrap'
import loading from '../../assets/loading.svg'
import {selectEwUser} from '../action/userActions'
import {selectEwGroup} from '../action/ewGroupActions'

class EwUsers extends Component{



    getGroup(groupList){
   
     var groups = ''
        if(groupList && groupList.length > 0){
            groupList.forEach(id => {

                var group = this.props.groups.filter(g =>{
              
                    return g['groupId'] == id
                })  
        
                if(group[0])
                groups += group[0]['name'] + ','
            });
          
        } 
        if(groups.length > 0){
        groups = groups.substring(0, groups.length - 1)
        }
        return groups;
    }

    getGroupObj(groupIdList){
        if(groupIdList && groupIdList.length > 0){
            var group = this.props.groups.filter(g =>{
                return g['groupId'] == groupIdList[0]
            })  

            this.props.dispatch(selectEwGroup(group[0]))
        }
    }

    getRows(){
        if(this.props.user){
            return <tr style={{cursor : 'pointer'}} key={ this.props.user['login']} >
       
                 <td>
                 {this.props.user['firstName'] + ' ' + this.props.user['lastName']}
                 </td>
       
                 <td>
               {this.props.user['email']}
                 </td>
       
            
       
                 </tr>
        }
        else{
            return this.props.users.map((g, index)=>{
                return  <tr style={{cursor : 'pointer'}} onClick={()=>{
              
                  this.getGroupObj(g['groupIdList'])
                  this.props.dispatch(selectEwUser(g))
                  
                  this.props.history.push('/create')
                }} key={g['userId'] + g['groupId'] + g['securityContextValue']} >
      
                <td>
                {g['firstName'] + ' ' + g['lastName']}
                </td>
      
                <td>
              {g['email']}
                </td>
      
    
                </tr>
            })
        }
    }

    render(){


 return this.props.loading ? <img src={loading} /> : <div>
     <Table striped bordered hover style={{maxHeight : '200px', minHeight : '200px'}}>
    <thead>
        <tr>
        
            <th>Name</th>
            <th>Email</th>
        </tr>
    </thead>
    <tbody style={{overflow : 'auto', height : '100px'}}>
    {this.getRows()}
 
    </tbody>
    </Table>

<Alert show={this.props.users.length == 0} variant="info">
<Alert.Heading>No Users!</Alert.Heading>
  <p>
      Add a user to this customer. 
  </p>
  </Alert>
 </div> 
    }
}

const mapStateToProps = state => (
    {
    users : state.acct.user.filteredUsers,
    loading : state.acct.user.filterLoading,
    groups: state.acct.ewGroup.groups,
    user : state.acct.user.selectedUser


  });

  export default connect(mapStateToProps)(withRouter(EwUsers))